export default "__VITE_ASSET__B446cRx$__"